export const isPrivateNipc = (nipc: string): boolean => {
	if (!nipc) {
		return false;
	}

	const firstChar: string = nipc[0];
	return firstChar === '1' || firstChar === '2' || firstChar === '3';
};
